import { Box, Button, Container, Grid, List, ListItem, Typography, useMediaQuery } from "@mui/material";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SquareLogo from "../../assets/beetogether-logo-520x520.png";
import Logo from "../../assets/beetogether-logo-extended.png";
import { theme } from "../../common/config/theme";

const Privacy: FC<{}> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const largeMediumScreen = useMediaQuery(theme.breakpoints.up("sm"));

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return <Container sx={{ p: 2, minHeight: "calc(100vh - 198px)", position: "relative" }}>
        <Box>
            <Button variant="outlined" onClick={() => navigate("/register")} sx={{ position: smallScreen ? "" : "absolute", top: 16, mb: 2 }}>
                {t("navigateBack")}
            </Button>
        </Box>
        <Grid container sx={{ mb: 5 }}>
            <Grid item xs={12}>
                {
                    smallScreen && <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                        <Box component="img" src={SquareLogo} sx={{ height: 150 }}></Box>
                    </Box>
                }
                {
                    largeMediumScreen && <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 2 }}>
                        <Box component="img" src={Logo} sx={{ width: "100%", maxWidth: 550 }}></Box>
                    </Box>
                }
                <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center" }}>
                    {t("privacyPage.title")}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, textAlign: "center" }}>
                    {t("privacyPage.title2")}
                </Typography>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {t("privacyPage.firstPointTitle")}
                </Typography>
                <Typography sx={{ textAlign: "justify" }}>
                    {t("privacyPage.firstPointParagraph1")}
                    <Typography component="span" sx={{ fontWeight: 600, textDecorationLine: "underline" }}>{t("privacyPage.firstPointEmailLink")}</Typography>
                    {t("privacyPage.firstPointParagraph2")}
                </Typography>
                <Typography variant="h6" sx={{ my: 2 }}>{t("privacyPage.secondPointTitle")}</Typography>
                <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.secondPointParagraph")}</Typography>
                <Typography variant="h6" sx={{ my: 2 }}>{t("privacyPage.thirdPointTitle")}</Typography>
                <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.thirdPointParagraph1")}</Typography>
                <List component="ol" sx={{ listStyleType: 'list-number', pl: 2 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.thirdPointOption1")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.thirdPointOption2")}</Typography>
                    </ListItem>
                </List>
                <Typography sx={{ textAlign: "justify", my: 2 }}>{t("privacyPage.thirdPointParagraph2")}</Typography>
                <Typography variant="h6" sx={{ my: 2 }}>{t("privacyPage.fourthPointTitle")}</Typography>
                <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.fourthPointParagraph")}</Typography>
                <Typography variant="h6" sx={{ my: 2 }}>{t("privacyPage.fifthPointTitle")}</Typography>
                <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.fifthPointParagraph1")}</Typography>
                <List component="ol" sx={{ listStyleType: 'lower-alpha', pl: 2 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.fifthPointOption1")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.fifthPointOption2")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.fifthPointOption3")}</Typography>
                    </ListItem>
                </List>
                <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.fifthPointParagraph2")}</Typography>
                <Typography variant="h6" sx={{ my: 2 }}>{t("privacyPage.sixthPointTitle")}</Typography>
                <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.sixthPointParagraph1")}</Typography>
                <List component="ol" sx={{ listStyleType: 'list-number', pl: 2 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.sixthPointOption1")}</Typography>
                    </ListItem>
                </List>
                <Typography variant="h6" sx={{ my: 2 }}>{t("privacyPage.seventhPointTitle")}</Typography>
                <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.seventhPointParagraph1")}</Typography>
                <List sx={{ listStyleType: 'lower-alpha', pl: 2 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.seventhPointOption1")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.seventhPointOption2")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.seventhPointOption3")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.seventhPointOption4")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.seventhPointOption5")}</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography sx={{ textAlign: "justify" }}>{t("privacyPage.seventhPointOption6")}</Typography>
                    </ListItem>
                </List>
                <Typography sx={{ textAlign: "justify" }}>
                    {t("privacyPage.seventhPointParagraph2")}
                    <Typography component="span" sx={{ fontWeight: 600, textDecorationLine: "underline" }}>
                        {t("privacyPage.seventhPointEmailLink")}
                    </Typography>
                </Typography>
            </Grid>
        </Grid>
    </Container>
}

export default Privacy;